define("auth/components/signup-form", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object", "@ember/service", "@ember/utils", "ember-concurrency-decorators", "ember-concurrency-ts", "later/utils/time-format", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _tracking, _object, _service, _utils, _emberConcurrencyDecorators, _emberConcurrencyTs, _timeFormat, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _trackCreateUser;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!-- Create an Account --}}
  <div data-test-id="signup-form" class="tSU--container">
    {{!-- Cards --}}
    <div class="tSU--container__row">
      {{!-- Card --}}
      <div class="tSU--card">
        <h1 class="tSU--card__title">{{t "authorization.create_account.title"}}</h1>
        <p class="tSU--card__subTitle">{{t "authorization.create_account.sub_title"}}</p>
  
        {{!-- Form Objects --}}
        <form
          class="u--p__t__lg"
          {{action (perform this.createUser identification password) on="submit"}}
        >
          {{!-- Name --}}
          <div class="o--formWrapper--lg">
            <label>{{t "authorization.create_account.label_name"}}</label>
            <Input
              @class="form-control o--form__input qa--signup_name_input"
              @placeholder={{t "authorization.create_account.placeholder_name"}}
              @value={{this.newUser.name}}
              {{autofocus}}
            />
          </div>
          {{!-- Email --}}
          <div class="o--formWrapper--lg">
            <label>{{t "shared_words.email"}}</label>
            <Input
              @type="email"
              @class="form-control o--form__input qa--signup_email_input"
              @placeholder={{t "authorization.create_account.placeholder_email"}}
              @value={{this.newUser.email}}
              {{on "focus" (set this "showErrors" false)}}
            />
          </div>
  
          {{!-- Password --}}
          <Shared::Credentials::PasswordInput
            @dataTestID="signup-password-input"
            @qaClassName="signup_password_input"
            @password={{this.newUser.password}}
          />
  
          <Shared::ProfileTimezoneSelect
            @user={{this.newUser}}
            @showToggle={{true}}
          />
  
          {{#if this.showErrors}}
            {{#if (is-present this.validations)}}
              {{#each this.validations as |validation|}}
                <p class="u--text--danger u--m__b__xs">
                  {{svg-jar "warning" class="o--icon u--m__r__xs"}}
                  {{html-safe validation.message}}
                </p>
              {{/each}}
            {{else if this.serverError}}
              <p class="u--text--danger u--m__b__xs">
                {{svg-jar "warning" class="o--icon u--m__r__xs"}}
                {{html-safe this.serverError}}
              </p>
            {{/if}}
          {{/if}}
  
          {{#if this.requiresExpressConsent}}
            <div data-test-id="express-consent-checkbox" class="o--form__checkbox">
              <label class="o--checkbox__label">
                <Input
                  @type="checkbox"
                  @checked={{this.expressConsent}}
                />
                {{t "authorization.create_account.express_consent"}}
              </label>
            </div>
          {{/if}}
  
          <div class="o--formSubmit">
            <Shared::Ui::Button
              type="submit"
              class="qa--signup_continue_button {{if isLoginDisabled "o--btn--disabled"}}"
              @size="large"
              @additional="block"
              @text={{t "authorization.create_account.page_title"}}
              @promise={{this.createUser}}
              @runningText={{t "shared_phrases.please_wait"}}
            />
          </div>
        </form>
  
        <p class="u--text--center u--m__b__lg u--m__t">
          {{t "authorization.already_have_an_account"}}
          <LinkTo @route="login" class="u--p__l__xs">
            {{t "authorization.sign_in"}}
          </LinkTo>
        </p>
  
        {{#unless this.requiresExpressConsent}}
          <p data-test-id="opt-in-text" class="u--text--light u--text--sm u--m__t__lg">{{t "authorization.create_account.opt_in"}}</p>
        {{/unless}}
        <p class="u--text--light u--text--sm">
          {{t "authorization.create_account.agreement"}}
          <Shared::Link
            @href="https://later.com/terms/"
            class="u--text--light u--text--underline"
          >
            {{t "authorization.create_account.terms"}}
          </Shared::Link>
          {{t "authorization.create_account.and"}}
          <Shared::Link
            @href="https://later.com/privacy/"
            class="u--text--light u--text--underline"
          >
            {{t "authorization.create_account.privacy"}}
          </Shared::Link>
        </p>
      </div>
  
      <div class="tSU--card tSU--card--testimonial">
        <p class="u--text--sm u--m__b__xs u--text--bold">{{t "authorization.create_account_banner.label"}}</p>
        <p class="tSU--card__title--featured tSU--highlight">{{t "authorization.create_account_banner.title"}}</p>
        {{!-- <object type="image/svg+xml" data="/assets/images/logos/logos-group.svg" class="tSU--card--testimonial__logos"></object> --}}
        <div class="tSU--card--testimonial__description u--text--center">
          <p class="u--text--italic">{{t "authorization.create_account_banner.testimonial"}}</p>
          <p class="u--text--bold u--m__b__0">{{t "authorization.create_account_banner.testimonial_author"}}</p>
          <p class="u--text--bold">{{t "authorization.create_account_banner.testimonial_company"}}</p>
        </div>
      </div>
    </div>
  </div>
  
  */
  {
    "id": "Hgq3E/bl",
    "block": "[[[10,0],[14,\"data-test-id\",\"signup-form\"],[14,0,\"tSU--container\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tSU--container__row\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n      \"],[10,\"h1\"],[14,0,\"tSU--card__title\"],[12],[1,[28,[35,0],[\"authorization.create_account.title\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"tSU--card__subTitle\"],[12],[1,[28,[35,0],[\"authorization.create_account.sub_title\"],null]],[13],[1,\"\\n\\n\"],[1,\"      \"],[11,\"form\"],[24,0,\"u--p__t__lg\"],[4,[38,1],[[30,0],[28,[37,2],[[30,0,[\"createUser\"]],[33,3],[33,4]],null]],[[\"on\"],[\"submit\"]]],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,[28,[35,0],[\"authorization.create_account.label_name\"],null]],[13],[1,\"\\n          \"],[8,[39,5],[[4,[38,6],null,null]],[[\"@class\",\"@placeholder\",\"@value\"],[\"form-control o--form__input qa--signup_name_input\",[28,[37,0],[\"authorization.create_account.placeholder_name\"],null],[30,0,[\"newUser\",\"name\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,[28,[35,0],[\"shared_words.email\"],null]],[13],[1,\"\\n          \"],[8,[39,5],[[4,[38,7],[\"focus\",[28,[37,8],[[30,0],\"showErrors\",false],null]],null]],[[\"@type\",\"@class\",\"@placeholder\",\"@value\"],[\"email\",\"form-control o--form__input qa--signup_email_input\",[28,[37,0],[\"authorization.create_account.placeholder_email\"],null],[30,0,[\"newUser\",\"email\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[1,\"        \"],[8,[39,9],null,[[\"@dataTestID\",\"@qaClassName\",\"@password\"],[\"signup-password-input\",\"signup_password_input\",[30,0,[\"newUser\",\"password\"]]]],null],[1,\"\\n\\n        \"],[8,[39,10],null,[[\"@user\",\"@showToggle\"],[[30,0,[\"newUser\"]],true]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showErrors\"]],[[[41,[28,[37,12],[[30,0,[\"validations\"]]],null],[[[42,[28,[37,14],[[28,[37,14],[[30,0,[\"validations\"]]],null]],null],null,[[[1,\"              \"],[10,2],[14,0,\"u--text--danger u--m__b__xs\"],[12],[1,\"\\n                \"],[1,[28,[35,15],[\"warning\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n                \"],[1,[28,[35,16],[[30,1,[\"message\"]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[1]],null]],[]],[[[41,[30,0,[\"serverError\"]],[[[1,\"            \"],[10,2],[14,0,\"u--text--danger u--m__b__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,15],[\"warning\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n              \"],[1,[28,[35,16],[[30,0,[\"serverError\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]],null]],[]]]],[]],null],[1,\"\\n\"],[41,[30,0,[\"requiresExpressConsent\"]],[[[1,\"          \"],[10,0],[14,\"data-test-id\",\"express-consent-checkbox\"],[14,0,\"o--form__checkbox\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"o--checkbox__label\"],[12],[1,\"\\n              \"],[8,[39,5],null,[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"expressConsent\"]]]],null],[1,\"\\n              \"],[1,[28,[35,0],[\"authorization.create_account.express_consent\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,0],[14,0,\"o--formSubmit\"],[12],[1,\"\\n          \"],[8,[39,17],[[16,0,[29,[\"qa--signup_continue_button \",[52,[33,18],\"o--btn--disabled\"]]]],[24,4,\"submit\"]],[[\"@size\",\"@additional\",\"@text\",\"@promise\",\"@runningText\"],[\"large\",\"block\",[28,[37,0],[\"authorization.create_account.page_title\"],null],[30,0,[\"createUser\"]],[28,[37,0],[\"shared_phrases.please_wait\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,2],[14,0,\"u--text--center u--m__b__lg u--m__t\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"authorization.already_have_an_account\"],null]],[1,\"\\n        \"],[8,[39,19],[[24,0,\"u--p__l__xs\"]],[[\"@route\"],[\"login\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,0],[\"authorization.sign_in\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"requiresExpressConsent\"]]],[[[1,\"        \"],[10,2],[14,\"data-test-id\",\"opt-in-text\"],[14,0,\"u--text--light u--text--sm u--m__t__lg\"],[12],[1,[28,[35,0],[\"authorization.create_account.opt_in\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"authorization.create_account.agreement\"],null]],[1,\"\\n        \"],[8,[39,21],[[24,0,\"u--text--light u--text--underline\"]],[[\"@href\"],[\"https://later.com/terms/\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,0],[\"authorization.create_account.terms\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[1,[28,[35,0],[\"authorization.create_account.and\"],null]],[1,\"\\n        \"],[8,[39,21],[[24,0,\"u--text--light u--text--underline\"]],[[\"@href\"],[\"https://later.com/privacy/\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,0],[\"authorization.create_account.privacy\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tSU--card tSU--card--testimonial\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--sm u--m__b__xs u--text--bold\"],[12],[1,[28,[35,0],[\"authorization.create_account_banner.label\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"tSU--card__title--featured tSU--highlight\"],[12],[1,[28,[35,0],[\"authorization.create_account_banner.title\"],null]],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"tSU--card--testimonial__description u--text--center\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--italic\"],[12],[1,[28,[35,0],[\"authorization.create_account_banner.testimonial\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--m__b__0\"],[12],[1,[28,[35,0],[\"authorization.create_account_banner.testimonial_author\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,0],[\"authorization.create_account_banner.testimonial_company\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"validation\"],false,[\"t\",\"action\",\"perform\",\"identification\",\"password\",\"input\",\"autofocus\",\"on\",\"set\",\"shared/credentials/password-input\",\"shared/profile-timezone-select\",\"if\",\"is-present\",\"each\",\"-track-array\",\"svg-jar\",\"html-safe\",\"shared/ui/button\",\"isLoginDisabled\",\"link-to\",\"unless\",\"shared/link\"]]",
    "moduleName": "auth/components/signup-form.hbs",
    "isStrictMode": false
  });

  let SignupFormComponent = (_class = (_trackCreateUser = /*#__PURE__*/new WeakSet(), class SignupFormComponent extends _component2.default {
    get isValid() {
      return (0, _utils.isEmpty)(this.validations);
    }

    get validations() {
      return this.newUser.validations.errors;
    }

    get requiresExpressConsent() {
      var _this$newUser;

      if (!((_this$newUser = this.newUser) !== null && _this$newUser !== void 0 && _this$newUser.timeZoneIdentifier)) {
        return false;
      }

      return _constants.EU_TZ_LIST.includes(this.newUser.timeZoneIdentifier);
    }

    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _trackCreateUser);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "errors", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "router", _descriptor4, this);

      _initializerDefineProperty(this, "session", _descriptor5, this);

      _initializerDefineProperty(this, "store", _descriptor6, this);

      _initializerDefineProperty(this, "segment", _descriptor7, this);

      _initializerDefineProperty(this, "userConfig", _descriptor8, this);

      _initializerDefineProperty(this, "segmentEvents", _descriptor9, this);

      _initializerDefineProperty(this, "newUser", _descriptor10, this);

      _initializerDefineProperty(this, "serverError", _descriptor11, this);

      _initializerDefineProperty(this, "showErrors", _descriptor12, this);

      _initializerDefineProperty(this, "expressConsent", _descriptor13, this);

      this.newUser = this.store.createRecord('user', {}); // NOTE: setupUserConfig call is used to setup list of timezones that ProfileTimezoneSelect uses

      this.userConfig.setupUserConfig(); // This prevents redirecting back to the `attemptedTransition` stored by ember-simple-auth.
      // Generally, we want to require new users to go through the onboarding flow.
      // https://ember-simple-auth.com/api/classes/SessionService.html

      this.session.set('attemptedTransition', null);
    }

    *createUser() {
      try {
        _classPrivateMethodGet(this, _trackCreateUser, _trackCreateUser2).call(this);

        if (!this.isValid) {
          this.showErrors = true;
          return;
        }

        this.showErrors = false;
        const {
          name,
          email,
          password,
          timeZone
        } = yield this.newUser;
        const accountParams = {
          gdprCompliant: this.expressConsent,
          gdprComplianceTimestamp: this.expressConsent ? (0, _timeFormat.timestamp)() : null
        };

        if (this.args.isUatTest) {
          this.router.transitionTo('profile_categorization', {
            queryParams: {
              force_categorization: true
            }
          });
        }

        yield (0, _emberConcurrencyTs.taskFor)(this.auth.createUser).perform(name, email, password, timeZone, accountParams);

        if (!this.session.isAuthenticated) {
          this.showErrors = true;
        }
      } catch (error) {
        // Little test to see how much people are returning without knowing they already have an account -iMack Feb 2022
        if (error !== null && error !== void 0 && error.message.toLowerCase().includes('another later account')) {
          this.segment.track('signup-attempt-already-exists');
        }

        this.showErrors = true;
        this.serverError = error.message;
      }
    }

    goToCalendar() {
      this.router.transitionTo('cluster.schedule.calendar');
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "segmentEvents", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "newUser", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "serverError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showErrors", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "expressConsent", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "createUser", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "createUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToCalendar"), _class.prototype)), _class);
  _exports.default = SignupFormComponent;

  function _trackCreateUser2() {
    this.segmentEvents.trackWithGAIntegration('clicked-create-account');
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SignupFormComponent);
});